import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';

export const ServiceEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" label="Service Name" required />
      <TextInput source="description" label="Description" multiline />
      <TextInput source="category" label="Category" />
      <SelectInput source="status" choices={[
        { id: 'Active', name: 'Active' },
        { id: 'Inactive', name: 'Inactive' },
      ]} />
    </SimpleForm>
  </Edit>
);
